var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"name":_vm.$options.name,"title":"TesztModal"},on:{"close":_vm.resetModal},scopedSlots:_vm._u([{key:"body",fn:function(){return undefined},proxy:true},{key:"footer",fn:function(){return undefined},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }